module.exports = __webpack_public_path__ + "img/feature_buy_th.1f2ca610.png";